const getters = {
  getMapIsInitialized: (state) => {
    if (state.isInitializing) {
      return false
    }
    return state.herePlatform != null &&
    state.hereDefaultLayer != null &&
    state.hereMarkers != null &&
    state.hereMap != null &&
    state.hereMapBehaviors != null
  },
  getMapIsRouting: (state) => (!state.isRouting && !state.isRouting),
  getMapIsInitializing: (state) => (state.isInitializing),
  getMapRoutingOptions: (state) => (state.routingOptions),
  getMapRoutingMarkers: (state) => (state.routingMarkers),
  getHereMapRouting: (state) => (state.hereRouting),
  getHereMap: (state) => (state.hereMap),
  getHereMapPlatform: (state) => (state.herePlatform),
  getHereMapDefaultLayer: (state) => (state.hereDefaultLayer),
  getHereMapBehaviors: (state) => (state.hereMapBehaviors)
}

export default getters
